import React from 'react'
import "../../assets/css/payment.scss"

 const ChallengesBoxM = (props) => {
     return(
         <div className='challengesBoxM'>
             <div className='Plan'>{props.Plan}</div>
             <div className='Data'>Leverage - 1:100</div>
             <div className='LineSvg'></div>
             <div className='Data'>Profit Target (Phase 1 -30 Days) $2,000 (8%)</div>
             <div className='LineSvg'></div>
             <div className='Data'>Profit Target (Phase 2 -60 Days) $1,000 (4%)</div>
             <div className='LineSvg'></div>
             <div className='Data'>Max Loss - $2,500 (10%)</div>
             <div className='LineSvg'></div>
             <div className='Data'>Max Daily Loss - $1,250 (5%)</div>
             <div className='LineSvg'></div>
             <div className='Data'>Profit Split- 70%</div>
             <div className='LineSvg'></div>
             <div className='Data'>Bi Weekly Profit Split- Yes</div>
             <div className='LineSvg'></div>
             <div className='Data'>Max Capital Growth -$1 million</div>
         </div>
     )
 }

 export default ChallengesBoxM